import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Http, Response } from "@angular/http";
import { NavController, ViewController } from "ionic-angular";
import { Store } from "@ngrx/store";
import * as util from "ethereumjs-util";

import { AppState } from "../../app/app.reducer";
import { AppUtilities } from "../../app/app.utilities";
import { ConfirmationPage } from "../confirmation/confirmation";
import { NodeService } from "../../services/node.service";
import { Wallet, User } from "../../app/app.models";
import { WalletFetchAction } from "../../app/app.actions";
import { WatacardLoadingSerivce } from "../../services/watacard.loading.service";
import { HomePage } from "../home/home";
import { IdolsListPage } from "../idols-list/idols-list";
import { ConfigService } from "../../services/config.service";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "../../services/auth.service";

@Component({
  selector: "page-walletsend",
  templateUrl: "walletsend.html"
})
export class WalletsendPage {
  public formData: FormGroup;
  public user$: User;
  public wallet$: Wallet;
  private dollarAmount: any;
  private bitcoinValue: number;

  constructor(
    public formBuilder: FormBuilder,
    public navCtrl: NavController,
    public nodeService: NodeService,
    public store: Store<AppState>,
    public utilities: AppUtilities,
    private http: Http,
    private loadingService: WatacardLoadingSerivce,
    private configService: ConfigService,
    public viewCtrl: ViewController,
    private translateService: TranslateService,
    private authService: AuthService
  ) {
    this.user$ = this.authService.getUser();
    this.store.select("wallet").subscribe((wallet: Wallet) => {
      this.wallet$ = wallet;
      //this.getBitcoinValue();
    });

    this.formData = formBuilder.group({
      accountTo: [null, Validators.required],
      amount: [null, Validators.required]
    });
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad WalletsendPage");
  }

  ionViewWillEnter() {}

  getBitcoinValue() {
    this.http
      .get("https://api.coinbase.com/v2/prices/spot?currency=USD")
      .subscribe((res: Response) => {
        if (res) {
          this.bitcoinValue = parseFloat(res.json().data.amount);
        }
      });
  }

  onSubmit(formData) {
    var tx = this.loadingService.getTempTx();
    if (tx) {
      this.nodeService
        .getTransactionTemp(tx)
        .then((result: any) => {
          if (result.blockNumber) {
            this.sendNewTransaction(formData);
          } else {
            this.messageAlert();
          }
        })
        .catch(err => {
          this.messageAlert();
        });
    } else {
      this.sendNewTransaction(formData);
    }
  }

  sendNewTransaction(formData: any) {
    var send_ok = this.translateService.instant("walletsend.send_ok");
    var not_enough_balance = this.translateService.instant(
      "walletsend.not_enough_balance"
    );
    var fields_format = this.translateService.instant(
      "walletsend.fields_format"
    );
    var idioma = this.configService.getIdiom();
    // 1eth = 1000000000000000000 Wei
    if (this.formData.valid && this.isValidAddress(formData.value.accountTo)) {
      if (this.wallet$.watacoins > parseFloat(formData.value.amount)) {
        this.nodeService
          .sendWatacoins(
            this.wallet$.address,
            formData.value.accountTo,
            parseFloat(formData.value.amount) * 1000000
          )
          .then(
            (tx: any) => {
              this.utilities.alert(send_ok);
              console.log("transacción enviada " + tx);
              this.loadingService.setTemp(tx, null, null);
              this.navCtrl.setRoot(IdolsListPage);
            },
            error => {
              var message = "Error: replacement transaction underpriced";
              this.utilities.alert(error);
            }
          );
      } else {
        this.utilities.alert(not_enough_balance);
      }
    } else {
      this.utilities.alert(fields_format);
    }
  }

  isValidAddress(address: string): boolean {
    return util.isValidAddress(address) && address !== this.wallet$.address;
  }

  onInputTime($event) {
    let val = $event.target.value;
    this.dollarAmount = parseFloat(val) * this.bitcoinValue;
  }

  messageAlert() {
    var message_alert = this.translateService.instant("token.message_alert");
    this.utilities.alert(message_alert);
  }
}



// WEBPACK FOOTER //
// ./src/pages/walletsend/walletsend.ts